import React from 'react';
import {Linking, Platform} from 'react-native';
import {useDispatch, useSelector} from 'react-redux';
import {esiaLinkSelector, esiaUserNotAcceptSelector} from '../../../redux/selectors/login';
import {setRuntimeLoginStepState} from '../../../redux/actions/runtime/loginStep';
import {LoginState} from '../../../shared/models/login/loginStep';
import View from './view';
import {WebViewNavigation} from 'react-native-webview';
import {loginSlice} from '../../../redux/reducers/login';
import querystring from 'querystring';
import {loginStepSlice} from '../../../redux/reducers/runtime/loginStep';
import {addNotification} from '../../../redux/actions/snackbar';
import {SnackbarNotificationType} from '../../../shared/components/snackbar/model';
import {useModal} from '../../../shared/components/modal';

const ESIA_HOW_TO_PAGE = 'https://www.gosuslugi.ru/help/faq/login/70000002';
const LK_TEST_ESKSO = 'https://test-lk.eskso.ru';
const LK_PROD_ESKSO = 'https://lk.eskso.ru';
const LK_STAGE_ESKSO = 'https://stage-lk.eskso.ru';

export const Esia = () => {
  const dispatch = useDispatch();

  const link = useSelector(esiaLinkSelector);
  const isNotAccept = useSelector(esiaUserNotAcceptSelector);

  const modals = useModal();

  if (Platform.OS === 'web' && !isNotAccept) {
    if (link) window.open(link, '_self');
    dispatch(setRuntimeLoginStepState(LoginState.enter));
    return null;
  }

  const goBack = () => {
    dispatch(loginStepSlice.actions.setLoginStep(LoginState.enter));
    dispatch(loginSlice.actions.reset(null));
  };

  const openHowToPage = async () => {
    if (Platform.OS === 'web') {
      window.open(ESIA_HOW_TO_PAGE, '_blank');
    } else {
      const supported = await Linking.canOpenURL(ESIA_HOW_TO_PAGE);
      if (supported) {
        await Linking.openURL(ESIA_HOW_TO_PAGE);
      }
    }
  };

  const onNavigationStateChange = ({url}: WebViewNavigation) => {
    if (!url || !(url.startsWith(LK_PROD_ESKSO) || url.startsWith(LK_TEST_ESKSO) || url.startsWith(LK_STAGE_ESKSO)))
      return;

    const [, params = ''] = url.split('?');
    const {code, state} = querystring.parse(params);

    if (code && state) {
      dispatch(loginStepSlice.actions.setLoginStep(LoginState.esiaRegCardUnconfirmed));
      dispatch(loginSlice.actions.setEsiaCode({code, state}));
    } else {
      goBack();
      dispatch(
        addNotification({
          message: 'Не удалось получить код авторизации ЕСИА',
          type: SnackbarNotificationType.Error,
        }),
      );
    }
  };

  return (
    <View
      link={link}
      isNotAccept={isNotAccept}
      goBack={goBack}
      openHowToPage={openHowToPage}
      onNavigationStateChange={onNavigationStateChange}
    />
  );
};
